import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem, Select, SelectChangeEvent } from '@mui/material';

import { UserStatus } from 'api';

import { UserSearchesV2Filter } from '../type';

const styles = {
  dropdown: {
    minWidth: 140,
  },
} as const;

interface Props {
  filter: UserSearchesV2Filter;
  setFilter: (filter: UserSearchesV2Filter) => void;
}
enum StatusValues {
  Active = 'active',
  Inactive = 'inactive',
}

const StatusDropdown: FC<Props> = ({ filter, setFilter }) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const [selectValue, setSelectValue] = useState<StatusValues>(getInitialValue());

  function getInitialValue() {
    return filter.user_status === UserStatus.Active ? StatusValues.Active : StatusValues.Inactive;
  }

  function onChange(event: SelectChangeEvent<StatusValues>) {
    const { value } = event.target;
    setSelectValue(value as StatusValues);

    switch (value) {
      case StatusValues.Active:
        setFilter({ ...filter, user_status: UserStatus.Active });
        break;
      case StatusValues.Inactive:
        setFilter({ ...filter, user_status: UserStatus.Disabled });
        break;
    }
  }

  return (
    <Select
      variant="standard"
      SelectDisplayProps={{ style: { padding: 12 } }}
      sx={styles.dropdown}
      value={selectValue}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      onChange={onChange}
    >
      <MenuItem value={StatusValues.Active}>{t('common:active')}</MenuItem>
      <MenuItem value={StatusValues.Inactive}>{t('common:inactive')}</MenuItem>
    </Select>
  );
};

export default StatusDropdown;
